import React, { useContext, useEffect, useState } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';

import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';
import useProviderTypeService from '../../../app/services/hooks/useProviderTypeService';
import { ProviderType } from '../../../app/models/ProviderType';
import ProviderTypeFormContainer from './ProviderTypeFormContainer';

interface Props {
    providerTypeId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const ProviderTypeEdit = ({ providerTypeId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const {
        fetchingEditProviderType,
        editProviderType,
        fetchingUpdateProviderType,
        updateProviderType
    } = useProviderTypeService();

    const [providerType, setProviderType] = useState<ProviderType>({ name: '' });
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        editProviderType(providerTypeId, {
            onSuccess: (response: ServiceResponse) => {
                setProviderType(response.data.provider_type);
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando tipo de proveedor...');
        updateProviderType(providerTypeId, providerType, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditProviderType ? (
        <LazyLoading height="300" />
    ) : (
        <ProviderTypeFormContainer
            fetching={fetchingUpdateProviderType}
            action={update}
            cancel={cancel}
            providerType={providerType}
            setProviderType={setProviderType}
            errorFields={errorFields}
        />
    );
};

export default ProviderTypeEdit;
